module.exports = __webpack_public_path__ + "static/img/pokeball.97a3de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pokeball.png
// module id = SDDt
// module chunks = 1